import React, { FC } from 'react';
import { DownloadingIcon, FileDownloadDoneIcon, FileDownloadIcon, ReportIcon } from 'ia-react-core';
import { DefaultTheme } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { StyledIcon } from './DownloadStateIcon.styles';
import { DownloadState } from '../../interfaces/DownloadState';

export interface DownloadStateIconProps {
  downloadState: DownloadState;
  readyStateIcon?: React.FC<{}>;
  downloadingStateIcon?: React.FC<{}>;
  doneStateIcon?: React.FC<{}>;
  failedStateIcon?: React.FC<{}>;
  readyStateIconColor?: (theme: DefaultTheme) => string;
  downloadingStateIconColor?: (theme: DefaultTheme) => string;
  doneStateIconColor?: (theme: DefaultTheme) => string;
  failedStateIconColor?: (theme: DefaultTheme) => string;
}

const DownloadStateIcon: FC<DownloadStateIconProps> = ({
  downloadState,
  readyStateIcon = FileDownloadIcon,
  downloadingStateIcon = DownloadingIcon,
  doneStateIcon = FileDownloadDoneIcon,
  failedStateIcon = ReportIcon,
  readyStateIconColor = (theme: DefaultTheme) => theme.colors.blue5,
  downloadingStateIconColor = (theme: DefaultTheme) => theme.colors.gray4,
  doneStateIconColor = (theme: DefaultTheme) => theme.colors.green10,
  failedStateIconColor = (theme: DefaultTheme) => theme.colors.red14,
}) => (
  <>
    <CSSTransition in={downloadState === 'ready'} timeout={500} classNames="fade">
      <StyledIcon as={readyStateIcon} $displayOnLoad $getColor={readyStateIconColor} />
    </CSSTransition>
    <CSSTransition in={downloadState === 'downloading'} timeout={500} classNames="fade">
      <StyledIcon as={downloadingStateIcon} $displayOnLoad={false} $getColor={downloadingStateIconColor} />
    </CSSTransition>
    <CSSTransition in={downloadState === 'done'} timeout={500} classNames="fade">
      <StyledIcon as={doneStateIcon} $displayOnLoad={false} $getColor={doneStateIconColor} />
    </CSSTransition>
    <CSSTransition in={downloadState === 'failed'} timeout={500} classNames="fade">
      <StyledIcon as={failedStateIcon} $displayOnLoad={false} $getColor={failedStateIconColor} />
    </CSSTransition>
  </>
);

export default DownloadStateIcon;
